package fr.arcplex.network.template

// kdljs is ESM-only: @JsModule lets webpack bundle it statically (a runtime
// require() is invisible to the bundler and crashes the browser build), and
// @JsNonModule is additionally required by the JS/UMD compilation.
@JsModule("kdljs")
@JsNonModule
external object KdlJs {
    fun parse(kdl: String): dynamic
}

@JsFun("(kdl, lib) => { try { const r = lib.parse(kdl); if (r == null || r.output == null) return '[]'; return JSON.stringify(r.output); } catch (e) { return '[]'; } }")
external fun kdlParseBridge(kdl: String, lib: dynamic): String

actual fun kdlParseToJson(kdlBody: String): String = kdlParseBridge(kdlBody, KdlJs)
